import React from 'react';
import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';

import { getResizedMediaUrl } from '../../services/APIClient';


const HomepageArticles = ({
  featuredArticles,
}) => {
  let value = null;
  const featuredArticleElements = featuredArticles.rss.channel.item;

  value = (
    <div className="pt-l">
      <div className="row align-center pb-l">
        <div className="column">
          <h4>Featured Articles</h4>
        </div>
      </div>
      <div
        className="row small-up-1 medium-up-2 large-up-4"
        style={{ maxWidth: '1440px' }}
      >
        {/* Journal Article */}
        {featuredArticleElements.map((article) => {
          const url = getResizedMediaUrl(article.image_url, 335, 240);

          return (
            <div
              className="column mb-base"
              key={article.title}
            >
              <a
                href={article.link}
                target="_blank"
                className="black"
              >
                <div
                  className="journal bg-white"
                >
                  {/* Image */}
                  <div className="card-section">
                    <div
                      className="card-image card-image-no-margin hide-for-large lazyload"
                      style={{ height: '160px' }}
                      data-bg={url}
                    />
                    <div
                      className="card-image card-image-no-margin show-for-large lazyload"
                      data-bg={url}
                    />
                  </div>
                  <div style={{ padding: '0 0.5rem 0.5rem' }}>
                    <span
                      className="journal-title"
                      style={{ lineHeight: '1.2' }}
                    >{article.title}
                    </span>
                  </div>
                </div>
              </a>
            </div>
          );
        })}
      </div>
    </div>

  );
  return value;
};

export default HomepageArticles;



// WEBPACK FOOTER //
// ./js/src/components/homepage/HomepageArticles.jsx